import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbEllipsis,
} from '../../components/ui/breadcrumb';

// Site-wide breadcrumbs (arch doc §4.4): wires the EXISTING accessible breadcrumb primitive
// to the parent-map trail. Long trails collapse the middle. All labels via t(); no free text.
export default function ExperienceBreadcrumbs() {
  const { t } = useLanguage();
  const trail = useBreadcrumbs();
  if (!trail || trail.length <= 1) return null;

  const label = (c) => t(c.labelKey, c.fallbackKey ? t(c.fallbackKey, c.labelKey) : c.labelKey);

  // Collapse the middle when the trail is long: first, ellipsis, then the last two crumbs.
  const collapsed = trail.length > 4;
  const visible = collapsed ? [trail[0], null, trail[trail.length - 2], trail[trail.length - 1]] : trail;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {visible.map((c, i) => {
          if (c === null) {
            return (
              <React.Fragment key="ellipsis">
                <BreadcrumbItem>
                  <BreadcrumbEllipsis />
                </BreadcrumbItem>
                <BreadcrumbSeparator />
              </React.Fragment>
            );
          }
          const isLast = i === visible.length - 1 || c.current;
          return (
            <React.Fragment key={c.path || i}>
              <BreadcrumbItem>
                {isLast || !c.path ? (
                  <BreadcrumbPage>{label(c)}</BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link to={c.path}>{label(c)}</Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {i < visible.length - 1 && <BreadcrumbSeparator />}
            </React.Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
